import React from 'react';
import PropTypes from 'prop-types';
import Typography from '@mui/material/Typography';
import {makeStyles} from 'tss-react/mui';
import {createTheme, ThemeProvider} from '@mui/material/styles';

const theme = createTheme();
const useStyles = makeStyles()((theme) => ({
   campoLabel: {
      alignSelf: 'center',
      paddingRight: '8px',
      wordWrap: 'break-word',
      minWidth: '100px',
      width: '150px',
      cursor: 'default',
      float: 'left'
   },

   contenedor: {
      display: 'flex',
      width: '100%'
   },
   campo: {
      boxSizing: 'border-box',
      float: 'right',
      width: '100%'
   }
}));
/**
 * Agrega un label en el lado derecho de un componente. Cualquier otra propiedad sera redireccionada al componente *dsComponent*
 */
function LabelDecorator({
   label,
   className,
   labelProps,
   classNameLabel,
   classNameChildrenContainer,
   children,
   childrenContainerProps,
   required,
   ...others
}) {
   const {classes, cx} = useStyles();
   return (
      <div className={cx(classes.contenedor, className)} {...others}>
         {label && (
            <Typography className={cx(classes.campoLabel, classNameLabel)} {...labelProps}>
               {label}
               {required ? '*' : ''}:
            </Typography>
         )}
         <div className={cx(classes.campo, classNameChildrenContainer)} {...childrenContainerProps}>
            {children}
         </div>
      </div>
   );
}
LabelDecorator.propTypes = {
   /**
    * Texto label a mostrar.
    */
   label: PropTypes.string,
   /**
    * Clase a asignar al contenedor principal del componente.
    */
   className: PropTypes.string,
   /**
    * Clase a asignar al label del componente.
    */
   classNameLabel: PropTypes.string,
   /**
    * Clase a asignar al contenedor de __children__.
    */
   classNameChildrenContainer: PropTypes.string
};
export default LabelDecorator;
